import React, { useEffect, useRef, useState } from "react";
import { Quote, Star } from "lucide-react";
import ParticleBackground from "./ParticleBackground";
import "../../testimonials.css";

const testimonials = [
  {
    quote:
      "AlphaBeta4success coaching has truly exceeded our expectations by providing an exceptional coach for Abhilash and Arjun. The teaching approach was not only clear and structured but also highly motivating, helping him build both confidence and strong subject understanding. The tutor's dedication, patience, and ability to simplify complex concepts made a noticeable difference in abhilash and arjun's progress. Overall, it’s evident that alphabeta4success prioritizes quality education and student growth. Highly recommended for anyone looking for committed and result-oriented coaching.",
    name: "Abhilash Parent from Sivakasi",
    detail: "CBSE Grade 12th",
    rating: 5,
  },
  {
    quote:
      "We had a wonderful experience with online maths tuition! Ma’am Usha and Ma’am Swathi provided great support and guidance, making learning effective and easy for my daughter. The flexibility of online classes allowed her to attend comfortably from home.Thank you so much Usha & Swathi Mam.",
    name: "Anvi Parent from Noida",
    detail: "Grade 7th",
    rating: 5,
  },
  {
    quote:
      "Thank God for letting us know you and you all pitched in at the right moment and at the right pace that helped Nitin to ace the exams. You have stood as a moral support to him and to us as well,,Ur commitment towards his improvement and performance were exemplary and impeccable!!Forever indebted for your dedication,kindness ,love and support 🥰🥰🙏🏻🙏🏻Hope to continue with the team in the upcoming years as well!! Thank you @Mahalakshmi - Ramasubramaniam",
    name: "Nithin Parent from Kovilpatti",
    detail: "CBSE Grade 10th",
    rating: 5,
  },
  {
    quote:
      "At the starting, I was little week in both Maths and Physics and I was struggling with them. As I started to attend online classes, I was able to feel me improving.The teachers were very interactive and always there for clearing my doubts anytime. Math mam teaches clearly step by step and Physics mam explains the contents very well and simple and teaches the problems in a simpler way to understand. Both the teachers sends lots of sample papersBoth the teachers are friendly and interactive. Finally i was very satisfied while attending the exam. Thank you for everything.",
    name: "Sevvel from Rasipuram",
    detail: "CBSE Grade 12th",
    rating: 5,
  },
  {
    quote:
      "My son Dhruva has been a student of Ms.Usha for the past 3 years for Physics, it is a blessing to have such a wonderful teacher, she is undoubtedly phenomenal in her coaching and excellent support for the student at all times. Thank you Usha ma'am for being great support for Dhruva in Physics and getting a good grade. My son had also taken a brush up course for chemistry with Ms.Meena, she did a great job at the last moment of exams preparation of IGCSE. I definitely recommend their team without a second thought.",
    name: "Dhruva Parent from Bangalore",
    detail: "IBDP 12th",
    rating: 5,
  },
  {
    quote:
      "Kumudha Ma’am has been such a wonderful tutor for both Precalculus in 10th grade and Calculus in 11th. She is incredibly encouraging and always creates a positive learning environment. No matter how tough the material got, she was patient and supportive, and her kind approach made math feel so much less intimidating. She explained problems step by step in a way that was easy to understand and always made sure I felt confident before moving on. Her encouragement really motivated me to push through challenges and believe in myself. I’m so grateful for her guidance—she made learning math a genuinely uplifting experience.",
    name: "Neyha Parent from USA",
    detail: "Grade 10th",
    rating: 5,
  },
  {
    quote:
      "Our sincere thanks to Aruna mam for her constant encouragement positive motivation, special tests, insights into answering questions and all. She considered to drop the class to make Nitin concentrate on East scholarship exam. Nitin has studied the maximum hours with her",
    name: "Nithin Parent from Kovilpatti",
    detail: "CBSE Grade 10th",
    rating: 5,
  },
  {
    quote:
      "Meenakshi Ma’am has been an incredible tutor and mentor throughout my high school journey. She taught me Honors Chemistry in 10th grade and later guided me through both AP Biology and AP Chemistry in 11th. Her flexibility, patience, and dedication truly made a difference. She always took the time to explain concepts clearly, answered even my last-minute questions, and made sure I fully understood before moving forward. Balancing two AP sciences at once was challenging, but her constant support made it manageable. Thanks to her guidance, I felt well-prepared and confident going into my AP exams. I’m deeply grateful for everything she’s done to help me succeed.",
    name: "Neyha Parent from USA",
    detail: "Grade 10th",
    rating: 5,
  },
  {
    quote:
      "Thanks to Usha Mam for the support through the year to help and guide my daughter in these two subjects.",
    name: "Parmitaa Parent from Chennai",
    detail: "CBSE Grade 12th",
    rating: 5,
  },
  {
    quote:
      "We were initially introduced to the AB4S program through a friend, and to be honest, we were a bit skeptical especially about how it would work across the time difference between the US and India, as well as the rigor of the subjects.However, both of our daughter’s teachers exceeded our expectations. They were incredibly dedicated, took the time to understand the AP syllabus thoroughly, and consistently provided support with even the most challenging concepts. They not only guided her through exams but also played a significant role in building her confidence.Thanks to their efforts, our daughter achieved outstanding scores in all her Math and Science courses—often taking multiple classes in parallel (AP Bio , AP chemistry) We were truly amazed by how personalized and effective their teaching approach was. We feel fortunate to have had their support and would be happy to share more about our experience via phone or chat.",
    name: "Neyha Parent from USA",
    detail: "Grade 10th",
    rating: 5,
  },
  {
    quote:
      "A heartfelt gratitude note from us! 🥰🥰🙏🏻🙏🏻 Thanks is not the word to thank you all enough, especially with a profession like ours, where staying around the child becomes impossible ,and makes us feel guilty and doubtful about parenting almost every single day. Pathetically,that is the core hard truth.",
    name: "Neyha Parent from USA",
    detail: "Grade 10th",
    rating: 5,
  },
  {
    quote:
      "To the tutors who show up consistently and make every regular session count — thank you. Your structured lessons, clear explanations, and steady guidance make a real difference. You break down complex topics into manageable pieces and create an environment where questions are welcomed and understanding comes step by step. What stands out most is your consistency — the way you maintain quality, stay prepared, and keep students on track without overwhelming them. Those regular sessions build strong foundations, confidence, and genuine interest in the sciences.Your feedback is thoughtful and actionable, helping students improve not just their knowledge, but also how they approach learning.This kind of support might seem routine, but its impact is anything but ordinary. It’s what helps students grow steadily and succeed in the IB journey. Truly appreciate the effort and dedication you bring to every session.💙",
    name: "Vidyut",
    detail: "IBDP",
    rating: 5,
  },
];

export default function Testimonials() {
  const [index, setIndex] = useState(0);
  const startX = useRef(0);
  const intervalRef = useRef(null);

  const next = () =>
    setIndex((i) => (i + 1) % testimonials.length);

  const prev = () =>
    setIndex((i) => (i - 1 + testimonials.length) % testimonials.length);

  /* AUTO PLAY */
  useEffect(() => {
    intervalRef.current = setInterval(next, 4000);
    return () => clearInterval(intervalRef.current);
  }, []);

  const stop = () => clearInterval(intervalRef.current);
  const start = () =>
    (intervalRef.current = setInterval(next, 4000));

  /* SWIPE */
  const handleStart = (e) => {
    startX.current = e.touches[0].clientX;
  };

  const handleEnd = (e) => {
    const diff = e.changedTouches[0].clientX - startX.current;
    if (diff > 50) prev();
    if (diff < -50) next();
  };

  const current = testimonials[index];

  return (
    <section id="Testimonials" className="testimonial-section">
      <ParticleBackground/>
      <div className="tcontainer">

        <h2 className="heading">What Parents & Students Say about AB4S</h2>
        <p className="subheading">
          Real transformations, real results
        </p>

        {/* STORY MODE CARD */}
        <div
          onMouseEnter={stop}
          onMouseLeave={start}
        >
        {/* CARDS WRAPPER */}
          <div className="cards-wrapper">
            {[0, 1].map((offset) => {
              const i = (index + offset) % testimonials.length;
              const t = testimonials[i];

              return (
                <div key={i} className="card">
                  <div className="badge">Success Story</div>

                  <p>“{t.quote}”</p>

                <div className="stars">
                  {Array.from({ length: t.rating }).map((_, j) => (
                    <Star key={j} size={16} color="gold" fill="gold" />
                  ))}
                </div>

                <h4>{t.name}</h4>
                <span>{t.detail}</span>
              </div>
            );
          })}
        </div>
          
        </div>
        {/* DOTS */}
        <div className="dots">
          {testimonials.map((_, i) => (
            <div
              key={i}
              onClick={() => setIndex(i)}
              className={`dot ${i === index ? "active" : ""}`}
            />
          ))}
        </div>

        <div className="swipe-hint">
          ← swipe left/right like stories →
        </div>
      </div>
    </section>
  );
}